






















































import Vue from "vue";
import MenuClassComp from "../aufstellung/MenuClassComp.vue";
import MenuRoleComp from "../aufstellung/MenuRoleComp.vue";
import BuildChipComp from "./BuildChipComp.vue";
import { Build } from "models/Build";
import { Class } from "models/Klasse";
import { Role } from "models/Rolle";

export default Vue.extend({
	name: "AddBuildComp",
	data: () => ({
		build: {
			class: null,
			role: [{ id: 0 }],
		} as Build,
		selected: null as number,
	}),
	components: { BuildChipComp, MenuRoleComp, MenuClassComp },
	computed: {
		canAdd: function(): boolean {
			return this.build && this.build.class && this.build.role && !this.build.role.some(r => r.id === 0);
		},
	},
	methods: {
		pickClass: function(clss: Class): void {
			this.build.class = clss;
		},
		pickRole: function(role: Role): void {
			if (this.selected != null) {
				this.build.role.splice(this.selected, 1, role);
			} else {
				let index = this.build.role.findIndex(r => r.id === 0);

				if (index === -1) {
					index = this.build.role.length - 1;
				}

				this.build.role.splice(index, 1, role);
			}
		},
		addBuild: function(): void {
			this.$emit("add", { class: this.build.class, role: this.build.role });
			this.build.class = null;
			this.build.role = [{ id: 0 }] as Role[];
		},
		closeDialog: function(): void {
			this.$emit("add", null);
		},
		roleChange: function(change: string): void {
			if (change === "add") {
				this.build.role.push({ id: 0 } as Role);
			} else if (change === "remove") {
				this.build.role.pop();
			}
		},
		selectedChange: function(selected: number) {
			this.selected = selected;
		},
	},
});
